import { useEffect, useState } from "react";
import { CheckCircle2, Clock, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

// Public landing after a shop's customer pays (or cancels) a work-order link through Stripe Checkout.
export default function PayDone() {
  const params = new URLSearchParams(window.location.search);
  const state = params.get("state"), sid = params.get("session_id");
  const [status, setStatus] = useState(state === "paid" && sid ? "checking" : state || "cancelled");
  const [amount, setAmount] = useState(null);
  useEffect(() => {
    if (status !== "checking") return;
    api.paySession(sid).then((r) => { setAmount(r.amount); setStatus(r.paid ? "paid" : "pending"); }).catch(() => setStatus("paid"));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const box = {
    checking: ["Confirming your payment…", "This takes a few seconds.", Loader2, "text-[#9aa0a8]"],
    paid: ["Payment received — thank you!", amount ? `$${amount.toFixed(2)} was charged to your card. Your tint shop has been notified and a receipt from Stripe is on its way.` : "Your tint shop has been notified and a receipt from Stripe is on its way.", CheckCircle2, "text-[#3ecf8e]"],
    pending: ["Payment is processing", "Your bank is still confirming the charge. Your shop will see it as soon as it clears.", Clock, "text-[#f5a524]"],
    already: ["Already paid", "This invoice has already been paid — nothing more is due.", CheckCircle2, "text-[#3ecf8e]"],
    cancelled: ["Payment cancelled", "Nothing was charged. You can reopen the link from your shop's message any time.", XCircle, "text-[#f5a524]"],
  }[status] || ["Payment link", "This link is no longer valid — please ask your shop for a new one.", XCircle, "text-[#e5484d]"];
  const Icon = box[2];
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-[#0c1017] px-6 text-[#e8e9ec]" data-testid="pay-done-page">
      <div className="w-full max-w-sm space-y-4 rounded-lg border border-[#27324a] bg-[#121824] p-6 text-center">
        <Icon className={`mx-auto h-8 w-8 ${box[3]} ${status === "checking" ? "animate-spin" : ""}`} />
        <div className="text-[15px] font-semibold" data-testid="pay-done-title">{box[0]}</div>
        <p className="text-[12px] text-[#9aa0a8]" data-testid="pay-done-text">{box[1]}</p>
        <p className="text-[11px] text-[#6b7079]">You can close this page. Payments are processed securely by Stripe · powered by Xpattern.</p>
      </div>
    </div>
  );
}
